import { IconProps } from "../../utils/global-types/global-types";

const EditIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_286_85937)">
        <path d="M13.083 9a.583.583 0 0 0-.583.583v4.667a.584.584 0 0 1-.583.583H3.75a.584.584 0 0 1-.583-.583V6.083c0-.321.261-.583.583-.583h4.667a.583.583 0 1 0 0-1.167H3.75c-.965 0-1.75.785-1.75 1.75v8.167c0 .965.785 1.75 1.75 1.75h8.167c.965 0 1.75-.785 1.75-1.75V9.583A.583.583 0 0 0 13.083 9"></path>
        <path d="M7.47 8.468a.3.3 0 0 0-.08.15l-.413 2.062a.292.292 0 0 0 .344.343l2.062-.413a.3.3 0 0 0 .15-.08l4.615-4.615-2.063-2.062zM15.573 2.427a1.46 1.46 0 0 0-2.062 0l-.807.807 2.062 2.063.807-.808c.275-.275.427-.64.427-1.03s-.152-.757-.427-1.032"></path>
      </g>
      <defs>
        <clipPath id="clip0_286_85937">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default EditIcon;
